<template>
    <div class="analyzing" role="status" aria-live="polite">
        <!-- Mesma linguagem da pill da Central: o traço do monitor sendo desenhado. -->
        <svg class="analyzing-ecg" viewBox="0 0 240 48" fill="none" aria-hidden="true">
            <path class="analyzing-ecg-rail" :d="ecgPath" />
            <path class="analyzing-ecg-trace" :d="ecgPath" pathLength="1" />
        </svg>

        <p class="analyzing-title">{{ title }}</p>

        <div class="analyzing-phrase">
            <transition name="phrase" mode="out-in">
                <span :key="phraseIndex">{{ phrases[phraseIndex] }}</span>
            </transition>
        </div>
    </div>
</template>

<script>
const PHRASE_INTERVAL_MS = 1600

export default {
    name: 'MonitoringAnalyzingCmp',
    props: {
        title: {
            type: String,
            default: 'Analisando integrações',
        },
        phrases: {
            type: Array,
            default: () => ['Aguarde um instante...'],
        },
    },
    data() {
        return {
            phraseIndex: 0,
            ecgPath: 'M2 28H72l6-5 6 5h14l6-22 9 38 6-26 5 10h20l7-4 6 4H238',
        }
    },
    mounted() {
        if (this.phrases.length > 1) {
            this.phraseTimer = setInterval(() => {
                this.phraseIndex = (this.phraseIndex + 1) % this.phrases.length
            }, PHRASE_INTERVAL_MS)
        }
    },
    beforeDestroy() {
        clearInterval(this.phraseTimer)
    },
}
</script>

<style lang="scss" scoped>
$brand: var(--brand);

.analyzing {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 260px;
    padding: 24px;
    text-align: center;
    // Só aparece se a espera passar de 250ms: em rede rápida o conteúdo entra direto, sem piscar.
    animation: analyzing-in .25s ease .25s both;

    p {
        margin-bottom: 0;
    }
}

.analyzing-ecg {
    width: 240px;
    max-width: 100%;
    height: 48px;
    margin-bottom: 20px;

    path {
        stroke: $brand;
        stroke-width: 2;
        stroke-linecap: round;
        stroke-linejoin: round;
    }

    .analyzing-ecg-rail {
        opacity: .12;
    }

    .analyzing-ecg-trace {
        stroke-dasharray: .35 .65;
        animation: analyzing-trace 1.8s linear infinite;
        filter: drop-shadow(0 0 3px color-mix(in srgb, #{$brand} 35%, transparent));
    }
}

.analyzing-title {
    font-size: 1em;
    font-weight: 600;
    color: var(--text);
}

.analyzing-phrase {
    height: 1.5em;
    margin-top: 4px;
    overflow: hidden;
    font-size: .85em;
    color: var(--text-faint);

    span {
        display: inline-block;
    }
}

.phrase-enter-active,
.phrase-leave-active {
    transition: opacity .2s ease, transform .2s ease;
}

.phrase-enter {
    opacity: 0;
    transform: translateY(6px);
}

.phrase-leave-to {
    opacity: 0;
    transform: translateY(-6px);
}

@keyframes analyzing-in {
    from { opacity: 0; }
    to { opacity: 1; }
}

// Um "pulso" de 35% do traço percorrendo a linha, como a varredura de um monitor.
@keyframes analyzing-trace {
    from { stroke-dashoffset: 1; }
    to { stroke-dashoffset: 0; }
}

@media (prefers-reduced-motion: reduce) {
    .analyzing {
        animation: none;
    }

    .analyzing-ecg {
        .analyzing-ecg-rail {
            opacity: .35;
        }

        .analyzing-ecg-trace {
            display: none;
        }
    }

    .phrase-enter-active,
    .phrase-leave-active {
        transition: none;
    }
}
</style>
